
/// <reference path='../_all.ts' />

module shoppinglist {
  'use strict';

  export class ShoppingListLine {
    constructor(
      public ID: string,
      public Part: part.Part,
      public Qty: number,
      public PPU: number,
      public Availability: AvailabilityData,
      public Image: Image,
      public Discount: number,
      public PPUAufAnfrage: boolean,
      public YourPPU: number)
    {
    }
  }
}



